import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-edit-icon',
  templateUrl: './general-edit.component.html'
})
export class GeneralEditComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
